<template>
  <div class="chang-pwd-container">
    <div class="title">忘记密码</div>
    <div class="sub-title">通过{{ type === 'phone' ? '手机' : '邮箱' }}找回</div>
    <div class="form">
      <el-form ref="formRef" :model="findForm" :rules="formRules">
        <el-form-item :prop="type">
          <div class="inpt-label">{{ type === 'phone' ? '手机号' : '邮箱' }}</div>
          <el-input v-model="findForm[type]" :placeholder="type === 'phone' ? '输入手机号' : '输入邮箱'"> </el-input>
        </el-form-item>
        <el-form-item prop="code">
          <div class="validate">
            <div class="inpt-label">验证码</div>
            <el-input v-model="findForm.code" placeholder="输入验证码"> </el-input>
            <div class="tip" @click="validateCodePhone" v-if="!showNum">发送验证码</div>
            <div class="count_down" v-else>{{ countDown }} S</div>
          </div>
        </el-form-item>
        <el-form-item prop="password">
          <div class="inpt-label">新密码</div>
          <el-input v-model="findForm.password" placeholder="新密码" onfocus="this.type='password'" onpaste="return false" oncopy="return false"> </el-input>
        </el-form-item>
        <el-form-item prop="confirmPsd">
          <div class="inpt-label">确认密码</div>
          <el-input v-model="findForm.confirmPsd" placeholder="确认密码" onfocus="this.type='password'" onpaste="return false" oncopy="return false">
          </el-input>
        </el-form-item>
        <el-form-item align="center">
          <div class="login-btn" :loading="false" @click="findPsdClick">找回密码</div>
        </el-form-item>
      </el-form>
      <div class="back-login" @click="backLoginClick">返回&nbsp;&nbsp;<span class="bk-color" @click="changeCurrentCom('ValiCodeCom')">登录</span></div>
      <div class="form-bot">
        <div class="gap-row">或者</div>
        <div class="btn phone-btn" v-if="type === 'phone'" @click="changeCurrentCom('FindPwdByEmail')">通过邮箱找回</div>
        <div class="btn email-btn" v-else @click="changeCurrentCom('FindPwdByPhone')">通过手机找回</div>
      </div>
    </div>
  </div>
</template>
<script>
import { findPwdByPhone, validateCodePhoneApi, findPwdByEmail, validateCodeEmailApi } from '@/apis/index'
let timer = null
export default {
  name: 'WorkSpacePwd',
  props: {
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    let validateConfirmPsd = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.findForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      findForm: {
        phone: '',
        email: '',
        cid: '',
        code: '',
        password: '',
        confirmPsd: '',
      },
      formRules: {
        phone: [
          { required: true, message: '不能为空', trigger: 'blur' },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: '电话号码格式错误',
            trigger: 'blur',
          },
          {
            validator: (rule, value, callBack) => this.$checkTypeValidator(2, false, value, callBack),
            trigger: ['blur'],
          },
        ],
        code: [
          {
            required: true,
            message: '验证码不能为空',
            trigger: ['blur'],
          },
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: ['blur'] },
          {
            pattern:
              /^(?!\d+$)(?![A-Za-z]+$)(?![`~!@#\$%\^&\*\(\)\-_=\+\\\|\[\{\]\};:',<\.>/\?]+$)[A-Za-z\d`~!@#\$%\^&\*\(\)\-_=\+\\\|\[\{\]\};:',<\.>/\?]{8,15}$/,
            message: '登录密码仅支持英文、数字、标点符号至少包含2种，长度8~15',
          },
        ],
        confirmPsd: [
          { required: true, message: '密码不能为空', trigger: ['blur'] },
          { required: true, validator: validateConfirmPsd, trigger: 'blur' },
        ],
        email: [
          { required: true, message: '邮箱地址不能为空', trigger: 'blur' },
          {
            pattern: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
            message: '邮箱不正确',
          },
          {
            validator: (rule, value, callBack) => this.$checkTypeValidator(3, false, value, callBack),
            trigger: ['blur'],
          },
        ],
      },
      showNum: false,
      countDown: 60,
    }
  },
  mounted() {},
  beforeDestroy(){
    timer = null
    clearInterval(timer)
  },
  methods: {
    findPsdClick() {
      this.$refs.formRef.validate(async (v) => {
        if (!v) return
        let findReq = this.type === 'phone' ? findPwdByPhone : findPwdByEmail
        const { phone, email, cid, code, password } = this.findForm
        let reqForm = this.type === 'phone' ? { phone, cid, code, password } : { email, cid, code, password }
        let res = await findReq(reqForm)
        if (res.success) {
          this.$emit('findSuccess', res)
        } else {
          if (res.code === 1001) {
            this.$confirm(`该${this.type === 'phone' ? '手机号' : '邮箱'}暂未绑定账号，请重新输入`, '提示', {
              confirmButtonText: '确定',
              // cancelButtonText: '取消',
              type: 'warning',
            }).then(() => {
              this.$refs.formRef.resetFields()
            })
          }
        }
      })
    },
    validateCodePhone() {
      this.$refs.formRef.validateField([this.type], async (v) => {
        if (!v) {
          this.$message.success('验证码已发送，请注意查收')
          // 没有错误信息----验证通过
          // 获取短信验证码
          let validateReq = this.type === 'phone' ? validateCodePhoneApi : validateCodeEmailApi
          let res = await validateReq(this.findForm[this.type])
          if (res.success) {
            const { uuid, code } = res.data
            this.findForm.cid = uuid
            this.findForm.code = code
            this.showNum = true
            this.countDown = 60
            clearInterval(timer)
            timer = setInterval(() => {
              if (this.countDown > 0) {
                this.countDown -= 1
              } else {
                this.showNum = false
              }
            }, 1000)
          } else {
            this.$message.error(res.msg)
          }
        }
      })
    },
    backLoginClick() {
      this.$emit('findSuccess', {})
    },
    changeCurrentCom(com, loginCom = true) {
      this.$emit('changeCom', com, loginCom)
    },
  },
}
</script>
<style lang="less" scoped>
.chang-pwd-container {
  padding: 48px 40px;
  background: rgba(255, 255, 255, 1);
  border-radius: 10px 10px 10px 10px;
  .title {
    font-weight: bold;
    font-size: 32px;
    color: #03133d;
    line-height: 34px;
    .high-light {
      margin-left: 10px;
      color: #0677e7;
    }
  }
  .sub-title {
    margin-top: 12px;
    font-size: 18px;
    color: #68718b;
    line-height: 24px;
  }
  .form {
    margin-top: 32px;
    /deep/.el-input__inner {
      width: 380px;
      height: 44px;
      line-height: 44px;
      border-radius: 8px 8px 8px 8px;
      border: 1px solid #cdd0d8;
    }
    .base64img {
      margin-left: 12px;
      width: 100px;
      height: 38px;
    }
    .inpt-label {
      margin-bottom: 8px;
      font-size: 16px;
      font-weight: bold;
      color: #03133d;
      line-height: 22px;
    }
    .input {
      /deep/.el-input__inner {
        width: 268px;
      }
    }
    .tip,
    .count_down {
      position: absolute;
      right: 0;
      bottom: -22px;
      font-size: 14px;
      color: #006fba;
      line-height: 20px;
      cursor: pointer;
    }
    .count_down {
      cursor: default;
      color: #8e8e8e;
    }
    .login-btn {
      width: 380px;
      height: 54px;
      background: linear-gradient(160deg, #0c87f0 0%, #036fe2 100%);
      border-radius: 10px 10px 10px 10px;
      line-height: 54px;
      font-weight: bold;
      font-size: 16px;
      color: #ffffff;
      cursor: pointer;
    }
    .regist-tip {
      text-align: center;
      font-size: 14px;
      color: #68718b;
    }
    .regist-btn {
      color: #006fba;
      font-weight: bold;
    }
  }
  .back-login {
    text-align: center;
    color: #68718b;
    font-size: 14px;
    .bk-color {
      font-weight: bold;
      cursor: pointer;
      color: #006fba;
    }
  }
  .form-bot {
    margin-top: 24px;
    .gap-row {
      font-size: 14px;
      color: #68718b;
      &::before {
        content: '';
        vertical-align: middle;
        margin-top: -3px;
        margin-right: 13px;
        display: inline-block;
        width: 163px;
        height: 1px;
        background-color: #e6e8ec;
      }
      &::after {
        content: '';
        vertical-align: middle;
        margin-left: 13px;
        margin-top: -3px;
        display: inline-block;
        width: 163px;
        height: 1px;
        background-color: #e6e8ec;
      }
    }
    .btn {
      margin-top: 24px;
      width: 380px;
      height: 54px;
      text-align: center;
      line-height: 54px;
      border-radius: 10px 10px 10px 10px;
      border: 1px solid #e6e8ec;
      cursor: pointer;
    }
    .phone-btn {
      // margin-right: 16px;
      &::before {
        content: '';
        display: inline-block;
        vertical-align: middle;
        margin-top: -3px;
        margin-right: 12px;
        width: 24px;
        height: 24px;
        background-image: url(../../../assets/login/email.png);
        background-size: contain;
      }
    }
    .email-btn {
      &::before {
        content: '';
        display: inline-block;
        vertical-align: middle;
        margin-top: -3px;
        margin-right: 12px;
        width: 24px;
        height: 24px;
        background-image: url(../../../assets/login/phone.png);
        background-size: contain;
      }
    }
  }
}
</style>
